var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.05 0a.672.672 0 01.672.672V6.05a.672.672 0 01-.672.672H.672a.673.673 0 110-1.345h4.706V.672A.672.672 0 016.05 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.277 5.949a.672.672 0 01.672-.672h5.378a.673.673 0 010 1.345H6.622v4.706a.673.673 0 01-1.345 0z"
  })));
}

export default SvgIconPlus;